import { queryOptions } from '@tanstack/react-query';

import type { TourResolver } from './types';

/** One cache entry per resolver and store, shared by `start` and the help card's readiness. */
export function tourResolveQueryOptions(resolver: TourResolver, storeId: string | undefined) {
  return queryOptions({
    queryKey: ['tours', 'resolve', resolver.key, storeId ?? null] as const,
    queryFn: () => resolver.load({ storeId }),
    staleTime: 60_000,
    meta: { silentError: true },
  });
}
